export default __webpack_public_path__ + "static/media/SocialMediaIntegration.7e83feb4.png";